export const avatarContainerSize = 84;
export const avatarSize = 64;
